import { Stack } from '@mantine/core'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { getLoanAmounts } from 'app/state/ducks/loans/selectors'
import { loadLoanAmounts, loadLoanHistory } from 'app/state/ducks/loans/thunks'
import { LoanActionType } from 'app/models/dropdown-options'
import { formatDateToShow, formatNumberToCurrency, stringToDate, } from 'app/utils/util-functions'
import MainTable from 'app/views/components/Table/MainTable'
import { CleanedLoanHistoryData, LoanParams, LoanAmountsData } from 'app/models/loan-params'
import { getColumnDefs } from './table-columnDefs-loan-history'

type Props = {
  close: any
  loan: LoanParams
}

export default function HistoryForm({ loan }: Props) {
  const loanAmounts = useSelector(getLoanAmounts)

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(loadLoanHistory(loan.id ?? ''))
    dispatch(loadLoanAmounts(loan.id ?? ''))
  }, [loan.id])

  function cleanLoanHistory(
    loanAmounts: LoanAmountsData[]
  ): CleanedLoanHistoryData[] {

    return loanAmounts.map((item, index) => {
      const transactionAmount = index === 0 ? Number(item.amount) : Number(item.amount) - Number(loanAmounts[index - 1].amount)
      const endDateString = index === loanAmounts.length - 1 ? loan.endDate : loanAmounts[index + 1]?.effectiveDate
      const endDate = endDateString ? stringToDate(endDateString) : null

      // Determine transaction type with rate and maturity changes for amendments/edits
      const transactionType = LoanActionType.find(
        option => option.value == item.actionType
      )?.label ?? item.actionType

      const exportObj: CleanedLoanHistoryData = {
        id: `${item.effectiveDate}-${index}`, // Create unique ID using effectiveDate and index
        'Effective Date': formatDateToShow(item?.effectiveDate ? stringToDate(item.effectiveDate) : undefined),
        'Transaction Type': transactionType,
        'Transaction Amount': formatNumberToCurrency(transactionAmount, loan?.currency ?? 'USD'),
        'New Balance': formatNumberToCurrency(Number(item.amount), loan?.currency ?? 'USD'),
        'Base Rate': item.interestBaseRate ?? '',
        'Margin': item.margin ?? '',
        'All-In Rate': item.allInRate + '',
        'Maturity Date': formatDateToShow(endDate),
      };

      return exportObj;
    })
  }


  return (
    <Stack w="100%">
      <div
        style={{
          backgroundColor: '#A4CAFE',
          width: '100%',
          padding: '10px',
          color: 'black',
          fontSize: '14px',
          fontWeight: 'bold',
        }}
      >
        Loan History
      </div>
      <MainTable
        tableName='Loan History'
        csvExportEnabled={true}
        columnDefs={getColumnDefs()}
        data={cleanLoanHistory(loanAmounts)}
        enableTopToolbar={false}
        headerBackgroundColor='#F0EEEE'
        setRow={() => {
        }}
      />
    </Stack>
  )
}